var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"animated-number",class:{ negative: _vm.value < 0 },domProps:{"textContent":_vm._s(_vm.formattedValue)}})}
var staticRenderFns = []

export { render, staticRenderFns }